import {AttachmentFile} from '@hconnect/common/types'
import {dataTestId} from '@hconnect/uikit/src/common/utils/testingUtils'
import {HPButton} from '@hconnect/uikit/src/lib2'
import {useUpmPlantContext} from '@hconnect/upm'
import {Close, FileUploadOutlined} from '@mui/icons-material'
import {Stack} from '@mui/material'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../../../consts'
import {useUploadSalesForecast} from '../../../hooks'

import {ExcelPreview} from './ExcelPreview'
import {SalesForecastUploadStepHeader} from './SalesForecastUploadStepHeader'

interface StepSalesForecastPreviewProps {
  files: Array<AttachmentFile>
  cancelUpload: () => void
  onUploadComplete: () => void
}

export const StepSalesForecastPreview: React.FC<StepSalesForecastPreviewProps> = ({
  files,
  cancelUpload,
  onUploadComplete
}) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)
  const {plantId: plantCode} = useUpmPlantContext()

  const {mutate: uploadSalesForecast, isPending: isUploading} = useUploadSalesForecast()
  const file = files[0]

  const handleUpload = () => uploadSalesForecast({plantCode, file}, {onSuccess: onUploadComplete})

  return (
    <Stack spacing={3} {...dataTestId('step_sales_forecast_preview')}>
      <SalesForecastUploadStepHeader title={file.name} />
      <ExcelPreview file={file} />
      <Stack direction="row" sx={{justifyContent: 'flex-end'}} spacing={1}>
        <HPButton
          color="secondary"
          {...dataTestId('cancel_upload_button')}
          onClick={cancelUpload}
          startIcon={<Close />}
        >
          {t('common.cancel')}
        </HPButton>
        <HPButton
          variant="contained"
          {...dataTestId('upload_button')}
          onClick={handleUpload}
          startIcon={<FileUploadOutlined />}
          disabled={isUploading}
        >
          {t('common.upload')}
        </HPButton>
      </Stack>
    </Stack>
  )
}
